<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">{{ isEdit ? 'Edit' : 'Add' }} Location</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form class="locaiton-form" [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <mat-form-field class="flex-half">
        <mat-label>Name</mat-label>
        <input matInput autocomplete="off" type="text" formControlName="name" id="name" />
        @if (form.get('name')?.hasError('maxlength')) {
          <mat-error>Name must be less than 255 characters</mat-error>
        }
        @if (form.get('name')?.hasError('pattern') || form.get('name')?.hasError('noContent')) {
          <mat-error>
            Name must contain characters.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="flex-full">
        <mat-label>House Number</mat-label>
        <input
          matInput
          autocomplete="off"
          type="text"
          formControlName="houseNumber"
          id="houseNumber"
          [required]="locationRequired"
          />
          @if (form.get('houseNumber')?.hasError('required')) {
            <mat-error> House Number is Required. </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="flex-full">
          <mat-label>Direction Pre Suffix</mat-label>
          <input matInput autocomplete="off" type="text" formControlName="directionalPrefix" id="directionalPrefix" />
          @if (form.get('directionalPrefix')?.hasError('pattern')) {
            <mat-error>
              Invalid Directional Prefix
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="flex-full">
          <mat-label>Street Name</mat-label>
          <input
            matInput
            autocomplete="off"
            type="text"
            formControlName="streetName"
            id="streetName"
            [required]="locationRequired"
            />
            @if (form.get('streetName')?.hasError('required')) {
              <mat-error> Street Name is Required. </mat-error>
            }
            @if (
              !form.get('streetName')?.hasError('required') &&
              (form.get('streetName')?.hasError('pattern') || form.get('streetName')?.hasError('whitespace'))
              ) {
              <mat-error
                >
                Invalid Street Name
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex-full">
            <mat-label>Street Name Suffix</mat-label>
            <input matInput autocomplete="off" type="text" formControlName="streetNameSuffix" id="streetNameSuffix" />
            @if (form.get('streetNameSuffix')?.hasError('pattern')) {
              <mat-error>
                Invalid Street Name Suffix
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex-full">
            <mat-label>Direction Post Suffix</mat-label>
            <input
              matInput
              autocomplete="off"
              type="text"
              formControlName="directionalPostfix"
              id="directionalPostfix"
              />
              @if (form.get('directionalPostfix')?.hasError('pattern')) {
                <mat-error>
                  Invalid Directional Postfix
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="flex-full">
              <mat-label>Time Zone</mat-label>
              <input
                [lcsSingleSelect]="timeZoneSelect"
                ndtTimeZoneSelect
                autocomplete="off"
                type="text"
                formControlName="timeZone"
                id="time-zone"
                [required]="locationRequired"
                />
                <ndt-time-zone-select #timeZoneSelect></ndt-time-zone-select>
                @if (form.get('timeZone')?.hasError('required')) {
                  <mat-error> Time Zone Field is Required. </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-full">
                <mat-label>City</mat-label>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  formControlName="city"
                  id="city"
                  [required]="locationRequired"
                  />
                  @if (form.get('city')?.hasError('required')) {
                    <mat-error> City is Required. </mat-error>
                  }
                  @if (form.get('city')?.hasError('pattern') || form.get('city')?.hasError('whitespace')) {
                    <mat-error>
                      Invalid City name.
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field class="flex-half">
                  <mat-label>State</mat-label>
                  <input
                    autocomplete="off"
                    type="text"
                    formControlName="state"
                    id="state"
                    lcsStaticSelect
                    [lcsSingleSelect]="stateSelect"
                    [lcsStaticSelectValue]="form.get('state')?.value"
                    (search)="stateSearch($event)"
                    (reset)="stateSearchReset()"
                    (stateChanged)="handleStateChange($event)"
                    required
                    />
                    <lcs-static-select #stateSelect [displayWith]="stateDisplayWith" [autoActiveFirstOption]="false">
                      @for (states of states; track states) {
                        <lcs-option [value]="states.abbreviation">
                          {{ states.name }} - {{ states.abbreviation }}
                        </lcs-option>
                      }
                    </lcs-static-select>
                    @if (form.get('state')?.hasError('required')) {
                      <mat-error> State is Required. </mat-error>
                    }
                    @if (form.get('state')?.hasError('whitespace')) {
                      <mat-error>State cannot have whitespace</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field class="flex-full">
                    <mat-label>Postal Code</mat-label>
                    <input
                      matInput
                      autocomplete="off"
                      type="text"
                      formControlName="postalCode"
                      id="postalCode"
                      [required]="locationRequired"
                      />
                      @if (form.get('postalCode')?.hasError('required')) {
                        <mat-error> Postal Code is Required. </mat-error>
                      }
                      @if (
                        !form.get('postalCode')?.hasError('required') &&
                        (form.get('postalCode')?.hasError('invalidPostalCode') ||
                        form.get('postalCode')?.hasError('whitespace'))
                        ) {
                        <mat-error
                          >
                          Invalid Postal Code.
                        </mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field class="flex-full">
                      <mat-label>Country</mat-label>
                      <input
                        autocomplete="off"
                        type="text"
                        formControlName="country"
                        id="country"
                        lcsStaticSelect
                        [lcsSingleSelect]="countrySelect"
                        [lcsStaticSelectValue]="form.get('country')?.value"
                        (search)="countrySearch($event)"
                        (reset)="countrySearchReset()"
                        />
                        <lcs-static-select #countrySelect [displayWith]="countryDisplayWith">
                          @for (countries of countries; track countries) {
                            <lcs-option [value]="countries">
                              {{ countries }}
                            </lcs-option>
                          }
                        </lcs-static-select>
                      </mat-form-field>
                      <mat-form-field class="flex-full">
                        <mat-label>Comment</mat-label>
                        <input matInput autocomplete="off" type="text" formControlName="comment" id="comment" />
                        @if (form.get('comment')?.hasError('maxlength')) {
                          <mat-error>
                            Comment field limited to 50 characters.
                          </mat-error>
                        }
                      </mat-form-field>
                    </mat-dialog-content>
                    <mat-dialog-actions>
                      <button type="button" title="Add and Create Another" mat-stroked-button (click)="onCreate(true)">
                        {{ isEdit ? 'Save' : 'Add' }} and Create Another
                      </button>
                      <button type="submit" title="Add" mat-raised-button>{{ isEdit ? 'Save' : 'Add' }}</button>
                    </mat-dialog-actions>
                  </form>
                </lcs-loading-overlay>
